const ENGLISH_PUBLIC_TRAIL_CONTENT = {
  "PR1-CBC": {
    title: "Víbora Levada and Moinhos de Rei Trail",
    description:
      "This walking route combines striking scenery, history and biodiversity for a memorable experience.\n\nIt starts beside Oural Dam, in Abadim, Cabeceiras de Basto, providing an inviting starting point for an unforgettable hike.",
  },
  "PR5-CBC": {
    title: "Pisão and Nariz do Mundo Trail",
    description:
      "A circular mountain route through Serra da Cabreira, crossing villages, deep valleys and mountain paths.\n\nIt passes the ruins of the old Pisão settlement, follows the Cavez river and reaches Nariz do Mundo, one of the region’s most striking natural viewpoints. The route also includes Poço das Relvas and the village of Moscoso.",
  },
  "PR7-CBC": {
    title: "Cavez Riverside Trail",
    description:
      "The Cavez Riverside route follows a landscape shaped by water, vegetation and rural paths, crossing peaceful areas with close contact with nature.\n\nA pleasant trail for discovering the surroundings of Cavez, with cool shaded spots and scenery typical of the valley.",
  },
};

function trailCode(trail) {
  const source = String(trail?.name || trail?.title || trail?.filename || "").trim();
  const match = source.match(/\b((?:PR|GR|TK)\s*\d+(?:-[A-Z]+)?)\b/i);
  return match ? match[1].replace(/\s+/g, "").toUpperCase() : "";
}

export function localizePublicTrail(trail, language = "pt") {
  if (!trail || language !== "en") return trail;
  const stored = trail?.translations?.en || {};
  const fallback = ENGLISH_PUBLIC_TRAIL_CONTENT[trailCode(trail)] || {};
  const name = String(stored.name || stored.title || trail?.nameEn || trail?.titleEn || "").trim();
  const description = String(
    stored.shortDescription ||
      stored.description ||
      trail?.shortDescriptionEn ||
      trail?.descriptionEn ||
      fallback.description ||
      ""
  ).trim();
  const localizedName = name || (fallback.title ? `${trailCode(trail)} : ${fallback.title}` : "");
  if (!localizedName && !description) return trail;
  return {
    ...trail,
    ...(localizedName ? { name: localizedName, nome: localizedName, title: localizedName } : {}),
    ...(description ? { shortDescription: description, descriptionShort: description } : {}),
  };
}
